import axios, { AxiosResponse } from 'axios'
import {
  LLMResponse,
  MedicalNotesFormattedFetchParams,
  MedicalNotesResult,
  PostLLMFeedbackParams,
  UserLLMPromptPostParams
} from '~/interfaces/llm'

const { REACT_APP_API_HSTORY_URL: hstoryAPI } = process.env

export const fetchMedicalNotesFormattedForLLM = async (
  params: MedicalNotesFormattedFetchParams
): Promise<MedicalNotesResult> => {
  const { pathParam } = params
  const response = await axios.get(`${hstoryAPI}/patients/${pathParam.patientId}/medical-notes?formattedForLLM`)
  const { data }: AxiosResponse<MedicalNotesResult> = response
  return data
}

export const postUserLLMPrompt = async (params: UserLLMPromptPostParams): Promise<LLMResponse> => {
  const { body, header } = params
  const response = await axios.post(`${hstoryAPI}/gpt-chat`, body, {
    headers: header
  })
  const { data }: AxiosResponse<LLMResponse> = response
  return data
}

export const postLLMFeedback = async (params: PostLLMFeedbackParams): Promise<any> => {
  const { body } = params
  const response = await axios.post(`${hstoryAPI}/llm-feedback`, body)
  const { data }: AxiosResponse<any> = response
  return data
}
